import React, { useState, useEffect } from "react";
import { Row, Col, Button, AutoComplete, Input, Form, Skeleton } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import {
debounce,
EXPERIENCE_LEVELS,
getDeepCopy,
GetQueryParams,
GetEditQueryParams, isHC, isNonHC } from
"../../../../shared/helpers";

import {
getSearchSkills,
getCompanyDetailsSuggestions,
GetFilters,
getPersonalDetailsLocation,
updateJobs,
getJobTitles,
createGig,
createGigReset,
updateJobsReset,
getJobDetail,
getGigRoles,
ClearSearchSuggestions } from
"../../../../redux/actions";
import history from "../../../../routes/history";
import { useLocation } from "react-router-dom";
import editjobicon from "../../../../assets/img/editjob.png";
import deletejobicon from "../../../../assets/img/deletejob.png";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import store from "../../../../redux/store";
import TopAlert from "./../../../../components/TopNotification/TopAlert";
import { fetchProfileExperienceAPI, fetchToken } from "../../../../API/API";
import { getImageByStateCode } from "../../../CompanyProfile/components/cloudinary";
import "./ContractGig.css";
// Main Function
export default function ContractGig() {
  const locationn = useLocation();
  const dispatch = useDispatch();
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
  const getEditQuery = GetEditQueryParams(locationn.search);
  const isEditFromQuery = getEditQuery?.FromEdit === true;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const encodedArrayString = urlParams.get("Skills");
  const industryfill =
  isEditFromQuery &&
  getEditQuery?.Industry &&
  getEditQuery?.Industry != "undefined" ?
  getEditQuery?.Industry :
  locationn?.state?.FromEdit ?
  locationn?.state?.Industry :
  [];

  const [form] = Form.useForm();
  const token = store.getState().authReducer.user.authToken;
  const { Option } = Select;
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const profession =
  userProfile?.Professions?.ProfessionCode === null ?
  "HC" :
  localStorage.getItem("profession");
  var JobDurationArray = [
  "1 month",
  "2 months",
  "3 months",
  "4 months",
  "5 months",
  "6 months",
  "7 months",
  "8 months",
  "9 months",
  "10 months",
  "11 months",
  "1 year",
  "1+ years",
  "1 Week",
  "6 weeks",
  "10 weeks",
  "12 weeks",
  "13 weeks",
  "Negotiable"];


  const FromEdit = locationn.state?.FromEdit;

  const [indCheck, setIndCheck] = useState();
  const [indAddCheck, setIndAddCheck] = useState(false);
  const [skillCheck, setSkillCheck] = useState();
  const [skillAddCheck, setSkillAddCheck] = useState(false);
  const [skillLocationCheck, setSkillLocationCheck] = useState(0);
  const [gigduration, setgigduration] = useState(
  isEditFromQuery ?
  getEditQuery?.IdealContractLengthName || " " :
  locationn.state?.FromEdit ?
  locationn.state.IdealContractLengthName || " " ?
  locationn.state.IdealContractLengthName :
  " " :
  locationn.state?.PermanentJob && " ");

  const [workpolicy, setworkpolicy] = useState(
  isEditFromQuery ?
  getEditQuery?.WorkPolicy :
  locationn?.state?.FromEdit ?
  locationn.state?.WorkPolicy ?
  locationn.state?.WorkPolicy :
  "" :
  // : isHC(userProfile?.profile?.ProfessionCode) || isHC(profession)
  isHC(userProfile?.Professions?.ProfessionCode) || isHC(profession) ?
  " " :
  "");

  const [gigtitle, setgigtle] = useState(
  isEditFromQuery ?
  getEditQuery?.Title :
  locationn.state?.FromEdit ?
  locationn.state.Title :
  "");

  const [facultyn, setfacultyn] = useState(
  // locationn.state.FromEdit
  //   ? locationn.state.FacilityName
  //   : isNonHC(userProfile?.profile?.ProfessionCode)
  //   ? "faculty"
  //   : ""
  isEditFromQuery ?
  getEditQuery?.FacilityName :
  locationn.state?.FromEdit ?
  locationn?.state?.FacilityName ?
  locationn?.state?.FacilityName :
  " " :
  isNonHC(userProfile?.Professions?.ProfessionCode) || isNonHC(profession) ?
  " " :
  "");


  const [skilldensity, setskilldensity] = useState("");
  const [industrydensity, setindustrydensity] = useState("");
  const [desiredexp, setdesiredexp] = useState(
  isEditFromQuery ?
  getEditQuery?.Experience :
  locationn.state?.FromEdit && locationn.state.Experience);

  const [locationValue, setLocationValue] = useState(
  isEditFromQuery ?
  getEditQuery?.Location :
  locationn.state?.FromEdit ?
  locationn.state.Location :
  "");

  const [location, setLocation] = useState([]);

  const [skillValue, setskillValue] = useState(
  isEditFromQuery && getEditQuery?.Skills ?
  getEditQuery?.Skills[0]?.skillName :
  locationn.state?.FromEdit ?
  locationn.state.Skills?.length > 0 &&
  locationn.state.Skills[0]?.skillName :
  "");

  const [industryValue, setindustryValue] = useState(
  isEditFromQuery &&
  getEditQuery?.Industry &&
  getEditQuery?.Industry != "undefined" ?
  getEditQuery?.Industry?.length > 0 ?
  getEditQuery?.Industry?.[0]?.industryName :
  locationn.state?.FromEdit && locationn.state?.Industry?.length > 0 ?
  locationn.state?.Industry[0]?.industryName :
  "" :
  "");


  const decodedArrayString = decodeURIComponent(encodedArrayString);
  const [skillDetails, setskillDetails] = useState(
  isEditFromQuery ?
  getEditQuery?.Skills :
  FromEdit ?
  locationn.state.Skills :
  []);

  const [industryDetails, setindustryDetails] = useState(
  isEditFromQuery &&
  getEditQuery?.Industry &&
  getEditQuery?.Industry != "undefined" ?
  getEditQuery?.Industry :
  FromEdit ?
  locationn.state?.Industry :
  []);

  const [skillName, setSkillName] = useState("");
  const [industryName, setIndustryName] = useState("");
  const [percentage, setpercentage] = useState(
  locationn.state?.FromEdit ?
  locationn.state.Skills?.length > 0 ?
  locationn.state.Skills[0]?.SkillPercent :
  "" :
  "");

  const [percentage2, setpercentage2] = useState(
  locationn.state?.FromEdit && locationn.state?.Industry?.length > 0 ?
  locationn.state?.Industry[0]?.industryPercent :
  "");

  const [percentIndex, setpercentIndex] = useState();
  const [skillIndex, setskillIndex] = useState();

  const [locationObject, setLocationObject] = useState(
  isEditFromQuery ?
  getEditQuery?.locobj :
  locationn.state?.FromEdit ?
  locationn.state.locobj :
  "");


  const [mypercent, setmypercent] = useState(0);
  const [mypercent2, setmypercent2] = useState(
  isNonHC(profession) || isNonHC(userProfile?.Professions?.ProfessionCode) ?
  0 :
  100);

  const [skillPercentValidator, setskillPercentValidator] = useState(false);
  const [industryPercentValidator, setindustryPercentValidator] =
  useState(false);
  const [skillerror, setskillerror] = useState(false);
  const [skillErrorArray, setskillErrorArray] = useState([]);

  const [skillDecimalError, setSkillDecimalError] = useState(false);
  const [industryDecimalError, setIndustryDecimalError] = useState(false);

  const [skillDuplicateError, setskillDuplicateError] = useState(false);
  const [industryDuplicateError, setindustryDuplicateError] = useState(false);
  const [industryerror, setindustryerror] = useState(false);
  const [industryErrorArray, setindustryErrorArray] = useState([]);
  const [jobloading, setJobLoading] = useState(false);
  const [locobj, setlocobj] = useState();
  const [jobDurationError, setjobDurationError] = useState(false);
  const [titleError, setTitleError] = useState(false);
  const [desiredExpError, setdesiredExpError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingIndustry, setloadingIndustry] = useState(false);
  const [addSkillInput, setAddSkillInput] = useState("block");
  const [addSkillBtn, setaddSkillBtn] = useState("none");
  const [addIndustryInput, setaddIndustryInput] = useState("block");
  const [addIndustryBtn, setaddIndustryBtn] = useState("none");
  const [ExperienceLevels, setExperiencelevels] = useState();
  const [validationCheck, setValidationCheck] = useState(false);
  const [RoleName, setRoleName] = useState(
  locationn.state?.FromEdit ? locationn.state.Role : "");

  const [employerName, setEmployerName] = useState(
  locationn.state?.FromEdit ? locationn.state.employerName : "");

  const [wentWrongCheck, setWentWrongCheck] = useState(false);
  // const [WorkplacePolicy,setWorkplacePolicy] = useState(location.state.FromEdit? location.state.WorkplacePolicy:"")
  const [roleError, setRoleError] = useState(false);
  const [dummyJobRoles, setDummyJobRoles] = useState();
  const [titleOptions, setTitleOptions] = useState();
  const [topAlert, setTopAlert] = useState();
  const [skillSuggestionsError, setSkillSuggestionsError] = useState(false);
  const [industrySuggestionsError, setIndustrySuggestionsError] =
  useState(false);
  const [skillNameError, setSkillNameError] = useState(false);
  const [industryNameError, setIndustryNameError] = useState(false);
  const [FacilityOptions, setFacilityOptions] = useState();
  const [placeId, setPlaceId] = useState(
  locationn.state?.FromEdit ? locationn.state.placeId : "");

  const [tempskillValue, settempskillValue] = useState("");
  const [tempPercentage, setTempPercentage] = useState("");

  const [tempIndustryValue, setTempIndustryValue] = useState("");

  const filters = useSelector(
  (state) => state.getPersonalDetailsLocationReducer.location);


  const skills = useSelector((state) => state.getSearchSkillsReducer.skills);
  const industries = useSelector(
  (state) => state.getCompanyDetailsReducer.dropdown);

  const createSuccessfull = useSelector(
  (state) => state.createGigReducer.success);

  const createGigresp = useSelector((state) => state.createGigReducer.gig);
  const updateSuccess = useSelector((state) => state.UpdateJobReducer.success);
  const updateResp = useSelector((state) => state.UpdateJobReducer.jobs);

  const loadingJobCreate = useSelector(
  (state) => state.createGigReducer.loading);

  const loadingJobUpdate = useSelector(
  (state) => state.UpdateJobReducer.loading);

  const jobTitles = useSelector((state) => state.postJObReeducer.titles);
  const [jobFacility, setjobFacility] = useState();

  const arrr = Array.isArray(
  getEditQuery?.Experience ?
  getEditQuery?.Experience :
  locationn.state.Experience);

  const desiredExp = arrr ?
  desiredexp?.map((item) => item?.ExperienceLevelId) :
  locationn?.state?.FromEdit &&
  locationn?.state?.Experience?.ExperienceLevelId;
  const defaultValueInit = {
    skillValue,
    industryValue,
    rolee: locationn.state?.FromEdit ? locationn.state?.Role : "",
    employerName: locationn.state?.FromEdit ?
    locationn.state?.employerName :
    "",
    workpolicyy: isEditFromQuery ?
    getEditQuery?.WorkPolicy :
    locationn.state?.FromEdit && locationn.state?.WorkPolicy,
    gigtitless: isEditFromQuery ?
    getEditQuery?.Title :
    locationn.state?.FromEdit ?
    locationn.state?.Title :
    "",
    facultynn: isEditFromQuery ?
    getEditQuery?.FacilityName :
    locationn.state?.FromEdit ?
    locationn.state?.FacilityName :
    "",
    locationValuee: isEditFromQuery ?
    getEditQuery?.Location :
    locationn.state?.FromEdit ?
    locationn.state?.Location :
    "",
    desiredExp: desiredExp,
    JobDuration: isEditFromQuery ?
    getEditQuery?.IdealContractLengthName :
    locationn.state?.IdealContractLengthName &&
    locationn.state?.IdealContractLengthName
  };
  const Roles = useSelector((state) => state.roleReducer.roles);

  useEffect(async () => {
    var options = [];
    if (
    isNonHC(profession) || isNonHC(
    userProfile?.Professions?.ProfessionCode))
    {
      for (var i = 0; i < Roles?.IT_ROLES?.length; i++) {
        options = [
        ...options,
        {
          value: Roles?.IT_ROLES[i].RoleName
        }];

      }
    } else if (
    isHC(profession) || isHC(
    userProfile?.Professions?.ProfessionCode))
    {
      for (var i = 0; i < Roles?.HC_ROLES?.length; i++) {
        options = [
        ...options,
        {
          value: Roles?.HC_ROLES[i].RoleName
        }];

      }
    }
    setDummyJobRoles(options);
  }, [Roles]);

  useEffect(() => {
    if (FromEdit && skillDetails?.length > 0) {
      var percentnum = 0;
      for (let i = 0; i < skillDetails?.length; i++) {
        percentnum = skillDetails[i]?.SkillPercent + percentnum;
      }

      if (percentnum > 100) {
        setskillerror(true);
      } else {
        setaddSkillBtn("block");
        setAddSkillInput("none");
        setmypercent(percentnum);
        setskillerror(false);
      }
    } else if (getEditQuery?.FromEdit && skillDetails?.length > 0) {
      var percentnum = 0;
      for (let i = 0; i < skillDetails?.length; i++) {
        percentnum = skillDetails[i]?.SkillPercent + percentnum;
      }

      if (percentnum > 100) {
        setskillerror(true);
      } else {
        setaddSkillBtn("block");
        setAddSkillInput("none");
        setmypercent(percentnum);
        setskillerror(false);
      }
    } else if (FromEdit && skillDetails === undefined) {
      setskillDetails([]);
    }
  }, []);

  useEffect(() => {
    if (FromEdit && industryDetails?.length > 0) {
      let percentnum = 0;
      for (let i = 0; i < industryDetails?.length; i++) {
        percentnum = industryDetails[i]?.industryPercent + percentnum;
      }

      if (percentnum > 100) {
        setindustryerror(true);
      } else {
        setaddIndustryBtn("block");
        setaddIndustryInput("none");
        setmypercent2(percentnum);
        setindustryerror(false);
      }
    } else if (getEditQuery?.FromEdit && industryDetails?.length > 0) {
      var percentnum = 0;
      for (let i = 0; i < industryDetails?.length; i++) {
        percentnum = industryDetails[i]?.industryPercent + percentnum;
      }

      if (percentnum > 100) {
        setindustryerror(true);
      } else {
        setaddIndustryBtn("block");
        setaddIndustryInput("none");
        setmypercent2(percentnum);
        setindustryerror(false);
      }
    } else if (FromEdit && industryDetails === undefined) {
      setindustryDetails([]);
    }
  }, []);
  // useEffect(() => {
  //   for (let i = 0; i < filters?.length; i++) {
  //     if (
  //       locationn.state.Location == filters[i].Location ||
  //       locationn.state.Location == filters[i].LocationWithCountry
  //     ) {
  //       let loc = filters[i];
  //       setlocobj({ loc });
  //     }
  //   }
  // }, [locationn.state?.Location, filters]);

  // useEffect(() => {
  //   let loc = filters[0];
  //   setlocobj({ loc });
  // }, [filters]);
  useEffect(() => {
    if (locationValue !== "") {
      dispatch(getPersonalDetailsLocation(locationValue));
    }
  }, [locationValue, locationn.state?.FromEdit]);

  useEffect(() => {
    if (locationValue?.length === 0) {
      setLocation("");
    }
  }, [location]);

  useEffect(() => {
    dispatch(updateJobsReset());
    dispatch(GetFilters());
    dispatch(getCompanyDetailsSuggestions());
    dispatch(getSearchSkills());
    // dispatch(getPersonalDetailsLocation(locationValue?.split(',')[0]));
  }, []);

  const getExperienceLevels = async () => {
    const expLevels = await fetchProfileExperienceAPI();
    setExperiencelevels(expLevels?.data);
  };
  useEffect(() => {
    getExperienceLevels();
  }, []);

  useEffect(() => {
    if (gigtitle === "") {
      setTitleOptions("");
    }
  }, [gigtitle, jobTitles]);

  //*********Get Job details*****/
  const jobdetails = useSelector(
  (state) => state.getJobDetailReducer.jobdetails);

  useEffect(() => {
    if (isEditFromQuery || FromEdit) {
      dispatch(
      getJobDetail(isEditFromQuery ? getEditQuery?.Id : locationn.state.Id));

    }
  }, [FromEdit, getEditQuery?.FromEdit]);
  //*************************/

  useEffect(() => {
    if (jobdetails?.length > 0 && FromEdit) {
      setlocobj(jobdetails[0]?.Location);
      form.setFieldsValue({
        locationValuee: jobdetails[0].Location?.LocationWithCountry
      });
      // form.setFieldsValue({...defaultValueInit , locationValuee : 'jobdetails[0].Location.LocationWithCountry'});
    }
    if (jobdetails?.length > 0 && isEditFromQuery) {
      setlocobj(jobdetails[0]?.Location);
      form.setFieldsValue({
        locationValuee: jobdetails[0].Location?.LocationWithCountry
      });
      // form.setFieldsValue({...defaultValueInit , locationValuee : 'jobdetails[0].Location.LocationWithCountry'});
    }
  }, [jobdetails]);

  useEffect(() => {
    var options = [];
    for (var i = 0; i < filters?.length; i++) {
      options = [
      ...options,
      {
        value: filters[i]?.LocationWithCountry
      }];

    }
    setLocation(options);
  }, [filters]);

  useEffect(() => {
    var skillsarray = [];
    for (var i = 0; i < skills?.length; i++) {
      skillsarray = [
      ...skillsarray,
      {
        value: skills[i].SkillName
      }];

    }
    setskilldensity(skillsarray);
  }, [skills]);

  useEffect(() => {
    var industriesarray = [];
    if (industries.length !== 0) {
      for (var i = 0; i < industries?.industries?.length; i++) {
        industriesarray = [
        ...industriesarray,
        {
          value: industries?.industries[i]?.IndustryName
        }];

      }
    }

    setindustrydensity(industriesarray);
  }, [industries]);

  useEffect(() => {
    if (createSuccessfull) {
      if (createGigresp) {
        dispatch(createGigReset());
        history.push({
          pathname: "/postjob/secondstep",
          state: {
            ...(locationn.state || {}),
            JobOrderId:
            isEditFromQuery && getEditQuery?.NotTemplate === true ?
            getEditQuery?.Id :
            locationn.state?.FromEdit &&
            locationn.state.NotTemplate == true ?
            locationn.state.Id :
            createGigresp?.JobOrderId,
            GigId:
            isEditFromQuery && getEditQuery?.NotTemplate === true ?
            getEditQuery?.Id :
            locationn.state?.FromEdit &&
            locationn.state.NotTemplate == true ?
            locationn.state.Id :
            createGigresp.JobOrderId,
            Title: createGigresp?.Title,
            JobOrderType: createGigresp?.JobOrderTypes?.JobOrderTypeName,
            FacilityName: locationn.state?.FacilityName ?
            locationn.state.FacilityName :
            createGigresp?.FacilityName,
            Skills: skillDetails,
            Location: `${createGigresp?.Cities?.CityName}, ${createGigresp?.Cities?.CityCode}`,
            Experience: createGigresp?.ExperienceLevels ?
            createGigresp?.ExperienceLevels :
            locationn.state?.Experience,
            Industry: industryDetails,
            Id:
            locationn.state?.FromEdit && locationn.state.NotTemplate == true ?
            locationn.state.Id :
            createGigresp?.JobOrderId,
            Description:
            createGigresp?.Description ?? locationn.state?.Description,
            WorkAuthorization:
            createGigresp?.WorkAuthorization?.length > 0 ?
            createGigresp?.WorkAuthorization :
            locationn.state?.WorkAuthorization,
            isTemplate:
            createGigresp?.isTemplate ?? locationn.state?.isTemplate,
            FromEdit: locationn.state?.FromEdit,
            IdealContractLengthName: gigduration,
            BudgetMin: locationn.state?.FromEdit ?
            locationn.state?.BudgetMin :
            0,
            PermanentJob: locationn.state?.PermanentJob,
            Role: RoleName,
            employerName: employerName,
            workpolicy: workpolicy,
            certificates: isEditFromQuery ?
            getEditQuery?.certificates ?
            getEditQuery?.certificates :
            [] :
            locationn.state?.certificates,
            // saveAsTemplate: locationn.state.saveAsTemplate,
            saveAsTemplate: locationn.state?.saveAsTemplate ?
            locationn.state?.saveAsTemplate :
            locationn.state?.isTemplate,
            locobj:
            locobj == undefined || locobj == null ?
            locationn.state?.locobj :
            locobj,
            placeId: placeId,
            NotTemplate: true,
            img: getImageByStateCode(
            locationn.state?.locobj ?
            locationn.state.locobj?.RegionCode :
            locobj?.RegionCode,
            locationn.state?.locobj ?
            locationn.state.locobj?.CityName :
            locobj?.CityName),

            openPositions: locationn.state?.openPositions,
            IdealTerms: locationn.state.IdealTerms || []
          }
        });
      } else {
        setWentWrongCheck(true);
      }
    }
  }, [createSuccessfull]);

  useEffect(() => {
    if (updateSuccess) {
      dispatch(updateJobsReset());

      let skills = skillDetails?.map((item) => {
        return {
          skillName: item.skillName,
          SkillPercent: item.SkillPercent,
          isDisable: true
        };
      });

      let industries = industryDetails?.map((item) => {
        return {
          industryName: item.industryName,
          industryPercent: item.industryPercent,
          isDisable: true
        };
      });

      dispatch(
      getJobDetail(isEditFromQuery ? getEditQuery?.Id : locationn.state?.Id));

      history.push({
        pathname: "/postjob/secondstep",
        state: {
          ...(locationn?.state || {}),
          GigId: isEditFromQuery ? getEditQuery?.Id : locationn.state?.Id,
          JobOrderId: isEditFromQuery ? getEditQuery?.Id : locationn.state?.Id,
          id: isEditFromQuery ? getEditQuery?.Id : locationn.state?.Id,
          Description: isEditFromQuery ?
          getEditQuery?.Description :
          locationn.state?.Description,
          WorkAuthorization: isEditFromQuery ?
          getEditQuery?.WorkAuthorization != "undefined" ?
          getEditQuery?.WorkAuthorization :
          [] :
          locationn.state?.WorkAuthorization,
          isTemplate: isEditFromQuery ?
          getEditQuery?.isTemplate :
          locationn.state?.isTemplate,
          FromEdit: isEditFromQuery ?
          getEditQuery?.FromEdit :
          locationn.state?.FromEdit,
          Id: isEditFromQuery ? getEditQuery?.Id : locationn.state?.Id,
          FacilityName: facultyn,
          Title: gigtitle,
          Skills: skillDetails,
          Industry: industries,
          // Location: `${createGigresp?.Cities?.CityName}',' ${createGigresp?.Cities?.CityCode}`,
          Location: isEditFromQuery ?
          getEditQuery?.Location :
          locationn.state.Location,
          // Experience: desiredexp,
          Experience: updateResp?.ExperienceLevels ?
          updateResp?.ExperienceLevels :
          locationn.state.Experience,
          IdealContractLengthName: gigduration,
          // IdealContractLengthName: createGigresp,
          BudgetMin: locationn.state?.FromEdit ?
          locationn.state?.BudgetMin :
          undefined,
          Role: RoleName,
          employerName: employerName,
          certificates: isEditFromQuery ?
          getEditQuery?.certificates != "undefined" ?
          getEditQuery?.certificates :
          [] :
          locationn.state?.certificates,
          img:
          locobj === undefined || locobj == null ?
          locationn.state.img :
          getImageByStateCode(
          locobj === undefined || locobj == null ?
          locationn.state.locobj.RegionCode :
          locobj?.RegionCode,
          locobj === undefined || locobj == null ?
          locationn.state.locobj.CityName :
          locobj.CityName),

          // img: locationn.state.img,
          PermanentJob: isEditFromQuery ?
          getEditQuery?.JobOrderTypeName === "Permanent" ?
          true :
          false :
          locationn.state.PermanentJob,
          workpolicy: workpolicy,
          JobOrderType: isEditFromQuery ?
          getEditQuery?.JobOrderTypeName :
          locationn.state?.JobOrderTypeName,
          saveAsTemplate:
          getEditQuery?.saveAsTemplate ??
          locationn.state?.saveAsTemplate ??
          locationn.state?.isTemplate,
          locobj:
          locobj == null || locobj == undefined ?
          locationn.state?.locobj :
          locobj,
          openPositions: isEditFromQuery ?
          getEditQuery?.openPositions :
          locationn.state.openPositions,
          IdealTerms: isEditFromQuery ?
          getEditQuery?.IdealTerms != "undefined" ?
          getEditQuery?.IdealTerms :
          [] :
          locationn.state.IdealTerms
        }
      });
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (skillDetails?.length == 0) {
      setAddSkillInput("block");
    }
  }, [skillDetails]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, [loading]);

  useEffect(() => {
    let skillErrorTempArr = [];
    for (let j = 0; j < skillDetails?.length; j++) {
      skillErrorTempArr[j] = false;
    }
    setskillErrorArray(skillErrorTempArr);
  }, []);

  useEffect(() => {
    let industryErrorTempArr = [];
    for (let j = 0; j < industryDetails?.length; j++) {
      industryErrorTempArr[j] = false;
    }
    setindustryErrorArray(industryErrorTempArr);
  }, []);

  const onSelect = (value) => {
    setLocationValue(value);
    for (let i = 0; i < filters.length; i++) {
      if (value === filters[i]?.LocationWithCountry) {
        setlocobj(filters[i]);
      }
    }
    setLocation("");

    // for (let i = 0; i < filters?.length; i++) {
    //   if (value=== filters[i].Location) {
    //     let loc = filters[i];
    //     setlocobj({ loc });
    //   }
    // }
  };

  const onSelectSkills = (value) => {
    setskillValue(value);
  };

  const onSelectRole = (value) => {
    // setRoleError(true);
    setRoleName(value);
  };

  const onSelectIndustries = (value) => {
    setindustryValue(value);
  };

  const validateLocation = () => {
    let status = false;
    for (let index = 0; index < filters.length; index++) {
      if (filters[index]?.LocationWithCountry == locationValue) {
        status = true;
        break; // No need to continue the loop if a match is found
      }
    }

    if (status) {
      setSkillLocationCheck(1);
      return true;
    } else {
      setSkillLocationCheck(2);
      return false;
    }
  };

  const isPermanentJobType = locationn.state?.PermanentJob ||
  locationn.state?.JobOrderTypeName == "Permanent" ||
  getEditQuery?.JobOrderTypeName == "Permanent";

  const ConGigSubmit = async () => {
    try {
      let errorCheck = false;
      setValidationCheck(true);
      await form.
      validateFields().
      then((values) => {}).
      catch((error) => {
        errorCheck = true;
      });
      setWentWrongCheck(false);

      if (!gigduration) {
        setjobDurationError(false);
      }
      if (!desiredexp) {
        setdesiredExpError(true);
      }
      if (mypercent !== 100) {
        setskillPercentValidator(true);
      }
      if (
      isNonHC(profession) ||
      isNonHC(userProfile?.Professions?.ProfessionCode) &&
      industryDetails.length > 0 &&
      mypercent2 !== 100)
      {
        setindustryPercentValidator(true);
      }

      let industries = industryDetails?.map((item) => {
        return {
          IndustryName: item.industryName,
          IndustryPercent: item.industryPercent,
          isDisable: true
        };
      });
      if (
      gigtitle.length > 0 && (
      locationValue !== "" || workpolicy === "fully-remote") &&
      !jobDurationError && (
      isPermanentJobType ? true : gigduration) &&
      !desiredExpError &&
      mypercent == 100 &&
      !errorCheck && (
      industryDetails.length > 0 ? mypercent2 == 100 : true))
      {
        if (
        FromEdit && locationn.state.NotTemplate ||
        isEditFromQuery && getEditQuery?.NotTemplate === true)
        {
          dispatch(
          updateJobs({
            Title: gigtitle,
            JobOrders_Skills: skillDetails,
            Industry: industries,
            IdealContractLengthName: gigduration,
            IdealTerms: isEditFromQuery ?
            getEditQuery?.IdealTerms != "undefined" ?
            getEditQuery?.IdealTerms :
            [] :
            locationn.state.IdealTerms,
            Location:
            workpolicy === "fully-remote" ?
            null :
            locobj == null || locobj == undefined ?
            locationn.state.locobj :
            locobj,
            ExperienceLevelId:
            desiredExp?.includes(null) ||
            desiredExp?.includes(undefined) ||
            desiredExp == undefined ?
            desiredexp :
            desiredExp,
            JobOrderTypeName: isEditFromQuery ?
            getEditQuery?.JobOrderTypeName :
            locationn.state?.JobOrderTypeName,
            // ? "Permanent"
            // : "Contract",
            id: isEditFromQuery ? getEditQuery?.Id : locationn.state?.Id,
            Role: RoleName,
            WorkplacePolicy: workpolicy,
            placeId: locationn.state?.placeId ?
            locationn.state?.placeId :
            placeId
          }));

        } else {

          dispatch(
          createGig({
            Title: gigtitle,
            JobOrders_Skills: skillDetails,
            Industry: industries,
            IdealContractLengthName: gigduration,
            data: locobj,
            Location:
            workpolicy === "fully-remote" ?
            null :
            locobj ?
            locobj :
            locationObject,
            ExperienceLevelId:
            desiredExp?.includes(null) ||
            desiredExp?.includes(undefined) ||
            desiredExp == undefined ?
            desiredexp :
            desiredExp,
            JobOrderStatusName: "Draft",
            JobOrderTypeName: isEditFromQuery ?
            getEditQuery?.JobOrderTypeName :
            locationn.state?.JobOrderTypeName,
            Role: RoleName,
            WorkplacePolicy: workpolicy,
            placeId: locationn.state?.placeId ?
            locationn.state?.placeId :
            placeId
          }));

        }
      } else console.warn("error");
    } catch (error) {}
  };
  const handleChange2 = (key) => {
    setdesiredexp(key.sort());
    setdesiredExpError(false);
  };

  const checkPercentage = (_, value) => {
    if (value > 0) {
      return Promise.resolve();
    } else if (value === "0") {
      return Promise.reject(new Error("Percentage must be greater than zero!"));
    }
  };
  const addSkillPercent = () => {
    let duplicateError = false;
    for (let i = 0; i < skillDetails?.length; i++) {
      if (skillDetails[i].skillName === skillValue) {
        duplicateError = true;
      }
    }
    setskillDuplicateError(duplicateError);
    var skillDetailsArray = [
    ...skillDetails,
    {
      skillName: skillValue,
      SkillPercent: parseInt(percentage),
      isDisable: true
    }];

    var skillNameArray = [...skillName, skillValue];

    var percentnum = 0;
    for (let i = 0; i < skillDetailsArray?.length; i++) {
      percentnum = skillDetailsArray[i].SkillPercent + percentnum;
    }

    if (percentnum > 100) {
      setskillerror(true);
    } else if (percentage % 1 != 0) {
      setSkillDecimalError(true);
    } else if (
    skillValue !== "" &&
    percentage !== "" &&
    percentage > 0 &&
    !duplicateError)
    {
      setSkillDecimalError(false);
      setskillerror(false);
      setaddSkillBtn("block");
      setAddSkillInput("none");
      setmypercent(percentnum);
      setskillDetails(skillDetailsArray);
      setSkillName(skillNameArray);
      setskillValue("");
      setpercentage("");
      setskillDuplicateError(false);
      setSkillAddCheck(true);
    }
    if (skillValue?.length == 0) {
      // setSkillSuggestionsError(true);
      setSkillNameError(true);
    } else {
      // setSkillSuggestionsError(false);
      setSkillNameError(false);
    }
  };

  useEffect(() => {
    if (mypercent == 100 && skillDetails?.length > 0) {
      setSkillCheck(true);
    } else {
      setSkillCheck(false);
    }
  }, [mypercent, skillDetails]);

  const editSkillsHandler = (index, item) => {
    setAddSkillInput("none");
    var skillsTempArray = getDeepCopy(skillDetails).map((el) => ({
      ...el,
      isDisable: true
    }));
    skillsTempArray[index] = {
      skillName: item.skillName,
      SkillPercent: parseInt(item.SkillPercent),
      isDisable: false
    };
    setskillValue(item?.skillName || "");
    setpercentage();
    setskillDetails(skillsTempArray);
    settempskillValue(item.skillName);
    setTempPercentage(item.SkillPercent);
    // setpercentage(item.SkillPercent);
  };

  const editSkills = (index) => {
    setSkillNameError(true);
    let duplicateError = false;
    let skillErrorTempArr = getDeepCopy(skillErrorArray);
    var skillsTempArray = getDeepCopy(skillDetails);
    var skillsCompArray = getDeepCopy(skillDetails);
    delete skillsCompArray[index];

    skillsTempArray[index] = {
      skillName:
      skillIndex === index && skillValue.length > 0 ?
      skillValue :
      skillDetails[index].skillName,
      SkillPercent: skillDetails[index].SkillPercent,
      isDisable: true
    };
    for (let i = 0; i < skillsCompArray?.length; i++) {
      if (
      skillValue?.length == 0 ?
      skillsCompArray[i]?.skillName === tempskillValue :
      skillsCompArray[i]?.skillName === skillValue)
      {
        duplicateError = true;
      }
    }
    setskillDuplicateError(duplicateError);
    let percentnum = 0;
    for (let i = 0; i < skillsTempArray?.length; i++) {
      percentnum = skillsTempArray[i].SkillPercent + percentnum;
    }

    if (percentnum > 100) {
      setskillerror(true);
      skillErrorTempArr[index] = true;
      setskillErrorArray(skillErrorTempArr);
    } else if (
    percentage !== undefined ? percentage % 1 != 0 : tempPercentage % 1 != 0)
    {
      setSkillDecimalError(true);
    } else if (
    skillsTempArray[index].skillName !== "" && (
    skillsTempArray[index].skillName === tempskillValue ||
    skillsTempArray[index].skillName === skillValue) &&
    skillsTempArray[index].SkillPercent !== "" &&
    skillsTempArray[index].SkillPercent > 0 &&
    !duplicateError)
    {
      setskillDetails(skillsTempArray);
      skillErrorTempArr[index] = false;
      setSkillDecimalError(false);
      setskillErrorArray(skillErrorTempArr);
      setmypercent(percentnum);
      setskillerror(false);
      setskillValue("");
      setSkillAddCheck(true);
      setskillDuplicateError(false);
      setpercentage("");
    }
    if (
    skillValue?.length == 0 ?
    skillsTempArray[index].skillName !== tempskillValue :
    skillsTempArray[index].skillName !== skillValue)
    {
      // setSkillSuggestionsError(true);
      setSkillNameError(true);
    } else {
      // setSkillSuggestionsError(false);
      setSkillNameError(false);
    }
  };

  const deleteSkill = (item, index) => {
    var skillsDeleteArray = getDeepCopy(skillDetails);
    let skillErrorTempArr = getDeepCopy(skillErrorArray);
    skillsDeleteArray.splice(index, 1);
    skillErrorTempArr.splice(index, 2);

    setskillDetails(skillsDeleteArray);
    setskillErrorArray(skillErrorTempArr);
    var percentnum = 0;
    for (let i = 0; i < skillsDeleteArray?.length; i++) {
      percentnum = skillsDeleteArray[i].SkillPercent + percentnum;
    }
    setmypercent(percentnum);
    setLoading(true);
    setpercentage("");
  };

  const addIndustryPercent = () => {
    let duplicateError = false;

    for (let i = 0; i < industryDetails?.length; i++) {
      if (industryDetails[i]?.industryName === industryValue) {
        // setskillDuplicateError(true);
        duplicateError = true;
      }
    }

    setindustryDuplicateError(duplicateError);

    var industryDetailsArray = [
    ...industryDetails,
    {
      industryName: industryValue,
      industryPercent: parseInt(percentage2),
      isDisable: true
    }];

    var industryNameArray = [...industryName, industryValue];

    var percentnum2 = 0;
    for (let i = 0; i < industryDetailsArray?.length; i++) {
      percentnum2 = industryDetailsArray[i].industryPercent + percentnum2;
    }

    if (percentnum2 > 100) {
      setindustryerror(true);
    } else if (percentage2 % 1 != 0) {
      setIndustryDecimalError(true);
    } else if (
    industryValue !== "" &&
    percentage2 !== "" &&
    percentage2 > 0 &&
    !duplicateError)
    {
      setaddIndustryBtn("block");
      setaddIndustryInput("none");
      setmypercent2(percentnum2);
      setindustryerror(false);
      setIndustryDecimalError(false);
      setindustryDetails(industryDetailsArray);
      setIndustryName(industryNameArray);
      setindustryValue("");
      setpercentage2("");
      setindustryDuplicateError(false);
      setIndAddCheck(true);
    }
    if (industryValue?.length == 0) {
      setIndustrySuggestionsError(true);
      setIndustryNameError(true);
    } else {
      setIndustrySuggestionsError(false);
      setIndustryNameError(false);
    }
  };

  useEffect(() => {
    if (mypercent2 == 100 && industryDetails?.length > 0) {
      setIndCheck(true);
    } else {
      setIndCheck(false);
    }
  }, [mypercent2, industryDetails]);

  const editIndustryHandler = (index, item) => {
    setaddIndustryInput("none");
    var industryTempArray = getDeepCopy([...industryDetails]).map((el) => ({
      ...el,
      isDisable: true
    }));

    industryTempArray[index] = {
      industryName: item.industryName,
      industryPercent: item.industryPercent,
      isDisable: false
    };
    setindustryDetails(industryTempArray);
    setindustryValue(item.industryName);
    setTempIndustryValue(item.industryName);
    setpercentage2(item.industryPercent);
  };

  const editIndustry = (index) => {
    let duplicateError = false;
    let industryErrorTempArr = getDeepCopy([...industryErrorArray]);
    var industryTempArray = getDeepCopy([...industryDetails]);
    var industryCompArray = getDeepCopy([...industryDetails]);
    delete industryCompArray[index];

    industryTempArray[index] = {
      industryName: industryValue,
      industryPercent: parseInt(percentage2),
      isDisable: true
    };
    for (let i = 0; i < industryCompArray?.length; i++) {
      if (
      industryValue?.length == 0 ?
      industryCompArray[i]?.industryName === tempIndustryValue :
      industryCompArray[i]?.industryName === industryValue)
      {
        duplicateError = true;
      }
    }
    setindustryDuplicateError(duplicateError);

    let percentnum = 0;
    for (let i = 0; i < industryTempArray?.length; i++) {
      percentnum = industryTempArray[i].industryPercent + percentnum;
    }
    if (percentnum > 100) {
      setindustryerror(true);
      industryErrorTempArr[index] = true;
      setindustryErrorArray(industryErrorTempArr);
    } else if (percentage2 % 1 != 0) {
      setIndustryDecimalError(true);
    }
    // industryValue !== "" && percentage2 !== "" && percentage2 > 0
    else if (
    industryTempArray[index].industryName !== "" && (
    industryTempArray[index].industryName === tempIndustryValue ||
    industryTempArray[index].industryName === industryValue) &&
    industryTempArray[index].industryPercent !== "" &&
    industryTempArray[index].industryPercent > 0 &&
    !duplicateError)
    {
      industryErrorTempArr[index] = false;
      setIndAddCheck(true);
      setindustryErrorArray(industryErrorTempArr);
      setindustryDetails(industryTempArray);
      setmypercent2(percentnum);
      setindustryerror(false);
      setIndustryDecimalError(false);
      setindustryDuplicateError(false);
    }
    if (industryValue?.length == 0) {
      setIndustrySuggestionsError(true);
      setIndustryNameError(true);
    } else {
      setIndustrySuggestionsError(false);
      setIndustryNameError(false);
    }
  };
  const deleteIndustry = (item, index) => {
    var industryDeleteArray = getDeepCopy([...industryDetails]);
    let industryErrorTempArr = getDeepCopy([...industryDeleteArray]);
    industryDeleteArray.splice(index, 1);
    industryErrorTempArr.splice(index, 1);

    setindustryDetails(industryDeleteArray);
    setindustryErrorArray(industryErrorTempArr);

    var percentnum = 0;
    for (let i = 0; i < industryDeleteArray?.length; i++) {
      percentnum = industryDeleteArray[i].industryPercent + percentnum;
    }
    setmypercent2(percentnum);
    setloadingIndustry(true);
    setpercentage2("");
  };

  useEffect(() => {
    if (industryDetails?.length == 0) {
      setaddIndustryInput("block");
    }
  }, [industryDetails]);

  useEffect(() => {
    setTimeout(() => setloadingIndustry(false), 1000);
  }, [loadingIndustry]);

  const dropdownSelect2 = (value) => {
    setgigduration(value);
  };

  const dropdownSelect3 = (value) => {
    setworkpolicy(value);
  };
  const getJobTitlesHandler = (e) => {
    // setTitleError(true);
    setJobLoading(true);
    dispatch(
    getJobTitles({
      title: e,
      professionCode: userProfile?.Professions?.ProfessionCode
    }));

    // var options = []
    // if (jobTitles?.length > 0) {
    //   for (var i = 0; i < jobTitles.length; i++) {
    //     options = [...options,
    //     {
    //       value: jobTitles[i].Title
    //     }]
    //   }
    //   setTitleOptions(options);
    // }
  };
  useEffect(() => {
    setJobLoading(false);
    var options = [];
    // for (var i = 0; i < filters.length; i++) {
    //   options = [
    //     ...options,
    //     {
    //       value: filters[i].LocationWithCountry,
    //     },
    //   ];
    // }
    // setLocation(options);

    if (jobTitles?.length > 0) {
      for (var i = 0; i < jobTitles?.length; i++) {
        options = [
        ...options,
        {
          value: jobTitles[i].Title,
          key: i
        }];

      }
      if (gigtitle !== "") {
        setTitleOptions(options);
      }
    }
  }, [jobTitles]);

  const getSearchSkillsHandler = (e, i) => {
    dispatch(
    getSearchSkills({
      search: e.target.value.trim(),
      // id: isNonHC(profession) || isNonHC(userProfile?.Profiles?.AccountTypeCode) ? 1 : 3
      id:
      isNonHC(profession) || isNonHC(
      userProfile?.Professions?.ProfessionCode) ?
      1 :
      3
    }));

    // setskillValue("");
    setskillIndex(i);
    settempskillValue(e.target.value);
    // var skillsarray = [];
    // for (var i = 0; i < skills?.length; i++) {
    //   skillsarray = [
    //     ...skillsarray,
    //     {
    //       value: skills[i]?.SkillName,
    //     },
    //   ];
    // }
    // setskilldensity(skillsarray);
  };

  // const changeTitleHandler = (e) => {
  //   // setTitleOptions("");
  //   setgigtle(e.target.value);
  // };

  const changeFacilityHandler = () => {
    setFacilityOptions("");
    setfacultyn("");
  };

  useEffect(() => {
    if (wentWrongCheck == true) {
      setTimeout(() => {
        setWentWrongCheck(false);
      }, 3000);
    }
  }, [wentWrongCheck]);

  const handleFacilityName = (e) => {
    setfacultyn(e.target.value);
    getFacilityRatings(e.target.value);
  };

  const getFacilityRatings = async (value) => {
    const response = axios.get(
    `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${value}&radius=${50000}&key=AIzaSyBT8M_kDmLfYYj8O7Y0CJjFt66dDLxPQFs`);

  };

  const getFacilityName = async (value) => {
    const headers = await fetchToken();
    const response = axios.get(
    `${BackendApiBaseUrl}/empgigs/suggestions?facilityName=${value}`,
    {
      headers
    });

    setjobFacility((await response).data);
  };
  useEffect(() => {
    var options = [];
    if (jobFacility?.length > 0) {
      for (var i = 0; i < jobFacility?.length; i++) {
        options = [
        ...options,
        {
          value: jobFacility[i].description,
          key: i,
          place_id: jobFacility[i].place_id
        }];

      }
      setFacilityOptions(options);
    }
  }, [jobFacility]);

  return (
    <Row className="contractgig-main">
      <Col xs={24} sm={24} md={22} lg={15}>
        {/* {topAlert ? (
            <TopAlert
              display={"flex"}
              title={"Please Select the Suggested values"}
              type="warning"
            />
           ) : null} */}
        <div
        className="contractgig-main2"
        style={{
          // width: "95%",
          // marginTop: !userProfile?.verification?.email  ? "5rem" : '32px',
          marginTop: "5px"
        }}>
          
          <Form
          form={form}
          layout="vertical"
          initialValues={defaultValueInit}
          onFinish={ConGigSubmit}>
            
            <Row className="contractgig-heading-resp">
              <div className="contractgig-title">Job Title</div>
              <div className="contractgig-asterik"> *</div>
            </Row>
            <div className="Place">
              <Form.Item
              name="gigtitless"
              rules={[
              {
                validator: (_, value) => {
                  if (gigtitle.length > 0) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(
                    new Error("Please add a job title"));

                  }
                }
              }]}>

                
                <AutoComplete
                popupClassName="post-job-form-dropdowns"
                size="large"
                onKeyPress={(event) => {
                  if (event.which === 13 /* Enter */) {
                    event.preventDefault();
                  }
                }}
                onClear={() => {
                  setTitleOptions("");
                  setgigtle("");
                }}
                onSearch={getJobTitlesHandler}
                options={titleOptions}
                filterOption={(inputValue, option) =>
                option.value.
                toUpperCase().
                indexOf(inputValue.toUpperCase()) !== -1}

                onSelect={(value) => {
                  setgigtle(value);
                }}>
                  
                  <Input
                  allowClear
                  type={"input"}
                  placeholder="Add your title here..."
                  onChange={(e) => setgigtle(e.target.value.trim())}
                  onKeyPress={(event) => {
                    if (event.which === 13 /* Enter */) {
                      event.preventDefault();
                    }
                  }} />
                  
                </AutoComplete>
              </Form.Item>
            </div>

            {isNonHC(userProfile?.Professions?.ProfessionCode) || isNonHC(
            profession) ?
            <>
                <Row className="contractgig-heading-resp">
                  <div className="contractgig-title">Workplace Policy</div>
                  <div className="contractgig-asterik"> *</div>
                </Row>
                <Form.Item
              name="workpolicyy"
              rules={[
              {
                required: true,
                message: "Please add workplace policy"
              }]}>

                
                  <Select
                placeholder="Add workplace policy"
                style={{
                  width: "100%",
                  border: "solid 1px #d4d4d4"
                }}
                size={"large"}
                className="workplace-policy-select"
                popupClassName="contract-gig-select-class post-job-form-dropdowns"
                onChange={dropdownSelect3}>
                  
                    <Option value="fully-remote">Fully remote</Option>
                    <Option value="hybrid">Hybrid</Option>
                    <Option value="on-prem">On-prem</Option>
                  </Select>
                </Form.Item>
              </> :
            null}

            <Row
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}>
              
              <Form.Item
              className="height-Input"
              name="skillValue"
              // rules={[]}
              >
                <Col className="contractgig-md123">
                  <Row className="contractgig-heading">
                    <div className="contractgig-title">Skill Density</div>
                    <div className="contractgig-asterik"> *</div>
                  </Row>

                  <div className="contractgig-cont">
                    <div className="contractgig-must">
                      Total skill percentage must equal 100%
                    </div>
                    <div style={{ width: "100%" }}>
                      {loading ?
                      <Skeleton /> :

                      <Row>
                          <Col span={24}>
                            {skillDetails?.map((item, index) => {
                            return (
                              <Row
                              className="contractgig-div"
                              style={{ marginTop: "1%" }}
                              key={index}>
                                
                                  <div
                                className="contractgig-div"
                                style={{ width: "80%" }}>
                                  
                                    <div style={{ width: "75%" }}>
                                      <AutoComplete
                                    popupClassName="post-job-form-dropdowns"
                                    options={skilldensity}
                                    style={{ width: "100%" }}
                                    onSelect={onSelectSkills}
                                    defaultValue={
                                    item?.skillName ?
                                    item?.skillName :
                                    null}

                                    disabled={item?.isDisable}
                                    filterOption={(inputValue, option) =>
                                    option.value.
                                    toUpperCase().
                                    indexOf(
                                    inputValue.toUpperCase()) !==
                                    -1}>

                                      
                                        <Input
                                      // className="contractgig-input"
                                      className={
                                      skillNameError ?
                                      "percentInputError" :
                                      "contractgig-input"}

                                      placeholder="Skill"
                                      type={"input"}
                                      onKeyPress={(event) => {
                                        if (
                                        event.which === 13 /* Enter */)
                                        {
                                          event.preventDefault();
                                        }
                                      }}
                                      value={skillValue}
                                      onChange={(e) => {
                                        setskillValue(
                                        e.target.value.trim());

                                        getSearchSkillsHandler(e, index);
                                      }}
                                      disabled={item?.isDisable} />
                                      
                                      </AutoComplete>
                                    </div>

                                    <div style={{ width: "20.5%" }}>
                                      <Input
                                    className={`contractgig-input ${
                                    skillerror && skillErrorArray[index] ?
                                    "percentInputError" :
                                    ""
                                    }`}
                                    placeholder="%"
                                    type={"input"}
                                    defaultValue={item?.SkillPercent}
                                    onKeyPress={(event) => {
                                      if (event.which === 13 /* Enter */) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onChange={(e) => {
                                      setpercentage(e.target.value.trim());
                                      setpercentIndex(index);
                                      var skillsTempArray =
                                      getDeepCopy(skillDetails);
                                      skillsTempArray[index] = {
                                        skillName:
                                        skillDetails[index].skillName,
                                        SkillPercent: parseInt(
                                        e.target.value),

                                        isDisable: false
                                      };
                                      setskillDetails(skillsTempArray);
                                    }}
                                    disabled={item?.isDisable} />
                                    
                                    </div>
                                  </div>
                                  {item.isDisable ?
                                <div className="contractgig-div editDeleteCont">
                                      <div>
                                        <img
                                    src={editjobicon}
                                    alt="editjobicon"
                                    style={{
                                      width: "20px",
                                      height: "20px"
                                    }}
                                    onClick={() =>
                                    editSkillsHandler(index, item)} />

                                    
                                      </div>
                                      <div>
                                        <img
                                    src={deletejobicon}
                                    alt="deletejobicon"
                                    style={{
                                      width: "20px",
                                      height: "20px"
                                    }}
                                    onClick={() =>
                                    deleteSkill(item, index)} />

                                    
                                      </div>
                                    </div> :

                                <div style={{ width: "15%" }}>
                                      <Col
                                  span={24}
                                  style={{
                                    display: "flex",
                                    // justifyContent: "flex-end",
                                    alignItems: "center",
                                    height: "88%"
                                  }}>
                                    
                                        <div
                                    onClick={() => {
                                      editSkills(index);
                                    }}
                                    className={"contractgig-add-btn"}>
                                      
                                          ADD
                                        </div>
                                      </Col>
                                    </div>}
                                
                                </Row>);

                          })}
                            {mypercent < 100 && addSkillInput === "block" ?
                          <Form.Item
                          name="skill"
                          rules={[
                          {
                            validator: (_, value) => {
                              if (skillDetails.length > 0) {
                                return Promise.resolve();
                              } else if (mypercent !== 100) {
                                setskillPercentValidator(true);
                              } else {
                                return Promise.reject(
                                new Error(
                                "Please enter skill density"));


                              }
                            }
                          }]}>

                            
                                <Row
                            className={`contractgig-div ${
                            skillDetails?.length > 0 ?
                            "input-top-margin" :
                            ""
                            } `}>
                              
                                  <div
                              className="contractgig-div"
                              style={{ width: "80%" }}>
                                
                                    <div style={{ width: "75%" }}>
                                      <AutoComplete
                                  popupClassName="post-job-form-dropdowns"
                                  options={skilldensity}
                                  style={{
                                    width: "100%"
                                  }}
                                  onSelect={onSelectSkills}
                                  defaultValue={
                                  isEditFromQuery ?
                                  getEditQuery?.Skills?.[0]?.
                                  SkillName :
                                  locationn.state?.FromEdit ?
                                  locationn.state.Skills?.length >
                                  0 &&
                                  locationn.state.Skills[0]?.
                                  SkillName :
                                  ""}

                                  filterOption={(inputValue, option) =>
                                  option.value.
                                  toUpperCase().
                                  indexOf(
                                  inputValue.toUpperCase()) !==
                                  -1}>

                                    
                                        <Input
                                    className={
                                    skillNameError ?
                                    "percentInputError" :
                                    "contractgig-input"}

                                    onKeyPress={(event) => {
                                      if (
                                      event.which === 13 /* Enter */)
                                      {
                                        event.preventDefault();
                                      }
                                    }}
                                    placeholder="Skill"
                                    type={"input"}
                                    value={skillValue}
                                    onChange={(e) => {
                                      setskillValue(
                                      e.target.value.trim());

                                      getSearchSkillsHandler(e);
                                    }} />
                                    
                                      </AutoComplete>
                                    </div>
                                    <div style={{ width: "20.5%" }}>
                                      <Input
                                  type={"input"}
                                  className={`contractgig-input ${
                                  skillerror ? "percentInputError" : ""
                                  }`}
                                  onKeyPress={(event) => {
                                    if (event.which === 13 /* Enter */) {
                                      event.preventDefault();
                                    }
                                  }}
                                  placeholder="%"
                                  value={percentage}
                                  onChange={(e) =>
                                  setpercentage(e.target.value.trim())} />

                                  
                                    </div>
                                  </div>
                                  <div style={{ width: "15%" }}>
                                    <Col
                                span={24}
                                style={{
                                  display: "flex",
                                  // justifyContent: "flex-end",
                                  alignItems: "center",
                                  height: "88%"
                                }}>
                                  
                                      <div
                                  onClick={() => addSkillPercent()}
                                  className={"contractgig-add-btn"}>
                                    
                                        ADD
                                      </div>
                                    </Col>
                                  </div>
                                </Row>
                              </Form.Item> :
                          null}
                            {skillerror ?
                          <div className="totalerrorMsg">
                                Total cannot be more than 100%
                              </div> :
                          skillDecimalError ?
                          <div
                          className="totalerrorMsg"
                          style={{ marginTop: "-6px" }}>
                            
                                Skill density percentage should be a whole
                                number
                              </div> :
                          skillDuplicateError ?
                          <div className="totalerrorMsg">
                                Duplicate skill names not allowed
                              </div> :
                          skillPercentValidator && mypercent < 100 ?
                          <div className="totalerrorMsg">
                                Total must be 100%
                              </div> :
                          null}
                            <div className="contractgig-Divider"></div>
                            <div className="contractgig-total">
                              Total: {mypercent}%
                            </div>
                            {mypercent < 100 &&
                          skillDetails?.length > 0 &&
                          skillDetails.every((el) => el.isDisable == true) ?
                          <div style={{ display: addSkillBtn }}>
                                <Button
                            className="add-new-skill-btn"
                            onClick={() => {
                              setskillDetails((prev) =>
                              prev.map((el) => ({
                                ...el,
                                isDisable: true
                              })));

                              setAddSkillInput("block");
                              setpercentage("");
                            }}>
                              
                                  <Row>
                                    <Col className="plus-Icon">+</Col>
                                    <Col className="btn-Text">
                                      Add a new Skill
                                    </Col>
                                  </Row>
                                </Button>
                              </div> :
                          null}
                          </Col>
                        </Row>}
                      
                    </div>
                  </div>
                </Col>
              </Form.Item>
              {(isNonHC(userProfile?.Professions?.ProfessionCode) || isNonHC(
              profession)) &&
              <Form.Item
              className="height-Input"
              name="industryValue"
              // rules={[]}
              >
                  <Col className="contractgig-md123">
                    <Row className="contractgig-heading head2">
                      <div className="contractgig-title">Industry Density</div>
                    </Row>
                    <div className="contractgig-cont">
                      <div className="contractgig-must">
                        Total industry percentage must equal 100%
                      </div>
                      <div style={{ width: "100%" }}>
                        {loadingIndustry ?
                      <Skeleton /> :

                      <Row>
                            <Col span={24}>
                              <div>
                                <div>
                                  {industryDetails?.map((item, index) => {
                                return (
                                  <Row
                                  className="contractgig-div"
                                  key={index}>
                                    
                                        <div
                                    className="contractgig-div"
                                    style={{ width: "80%" }}>
                                      
                                          <div style={{ width: "75%" }}>
                                            <AutoComplete
                                        popupClassName="post-job-form-dropdowns"
                                        options={industrydensity}
                                        style={{
                                          width: "100%"
                                        }}
                                        onKeyPress={(event) => {
                                          if (
                                          event.which === 13 /* Enter */)
                                          {
                                            event.preventDefault();
                                          }
                                        }}
                                        onSelect={onSelectIndustries}
                                        defaultValue={item.industryName}
                                        disabled={item.isDisable}
                                        filterOption={(
                                        inputValue,
                                        option) =>

                                        option.value.
                                        toUpperCase().
                                        indexOf(
                                        inputValue.toUpperCase()) !==
                                        -1}>

                                          
                                              <Input
                                          className="contractgig-input"
                                          placeholder="industry"
                                          type={"input"}
                                          onKeyPress={(event) => {
                                            if (
                                            event.which ===
                                            13 /* Enter */)
                                            {
                                              event.preventDefault();
                                            }
                                          }}
                                          defaultValue={item.industryName}
                                          onChange={(e) =>
                                          setindustryValue("")}

                                          disabled={item.isDisable} />
                                          
                                            </AutoComplete>
                                          </div>
                                          <div style={{ width: "20.5%" }}>
                                            <Input
                                        className={`contractgig-input ${
                                        industryerror &&
                                        industryErrorArray[index] ?
                                        "percentInputError" :
                                        ""
                                        }`}
                                        onKeyPress={(event) => {
                                          if (
                                          event.which === 13 /* Enter */)
                                          {
                                            event.preventDefault();
                                          }
                                        }}
                                        placeholder="%"
                                        type={"input"}
                                        defaultValue={
                                        item.industryPercent}

                                        onChange={(e) =>
                                        setpercentage2(
                                        e.target.value.trim())}


                                        disabled={item.isDisable} />
                                        
                                          </div>
                                        </div>
                                        {item.isDisable ?
                                    <div className="contractgig-div editDeleteCont">
                                            <div>
                                              <img
                                        src={editjobicon}
                                        alt="editjobicon"
                                        style={{
                                          width: "20px",
                                          height: "20px"
                                        }}
                                        onClick={() =>
                                        editIndustryHandler(
                                        index,
                                        item)} />


                                        
                                            </div>
                                            <div>
                                              <img
                                        src={deletejobicon}
                                        alt="deletejobicon"
                                        style={{
                                          width: "20px",
                                          height: "20px"
                                        }}
                                        onClick={() =>
                                        deleteIndustry(item, index)} />

                                        
                                            </div>
                                          </div> :

                                    <div style={{ width: "15%" }}>
                                            <Col
                                      span={24}
                                      style={{
                                        display: "flex",
                                        // justifyContent: "flex-end",
                                        alignItems: "center",
                                        height: "88%"
                                      }}>
                                        
                                              <div
                                        onClick={() =>
                                        editIndustry(index)}

                                        className={
                                        "contractgig-add-btn"}>

                                          
                                                ADD
                                              </div>
                                            </Col>
                                          </div>}
                                    
                                      </Row>);

                              })}
                                  {mypercent2 < 100 &&
                              addIndustryInput === "block" ?
                              <Form.Item
                              name="industry"
                              rules={
                              industryDetails?.length > 0 && [
                              {
                                validator: (_, value) => {
                                  if (mypercent2 == 100) {
                                    return Promise.resolve();
                                  } else if (
                                  industryDetails?.length > 0 &&
                                  mypercent2 !== 100)
                                  {
                                    setindustryPercentValidator(
                                    true);

                                  } else {
                                    return Promise.reject(
                                    new Error(
                                    "Please enter industry density"));


                                  }
                                }
                              }]}>


                                
                                      <Row
                                className={`contractgig-div ${
                                industryDetails?.length > 0 ?
                                "input-top-margin" :
                                ""
                                } `}>
                                  
                                        <div
                                  className="contractgig-div"
                                  style={{ width: "80%" }}>
                                    
                                          <div style={{ width: "75%" }}>
                                            <AutoComplete
                                      popupClassName="post-job-form-dropdowns"
                                      options={industrydensity}
                                      style={{
                                        width: "100%"
                                      }}
                                      onSelect={onSelectIndustries}
                                      defaultValue={
                                      locationn.state?.FromEdit &&
                                      industryfill?.length > 0 ?
                                      industryfill[0].IndustryName :
                                      ""}

                                      filterOption={(
                                      inputValue,
                                      option) =>

                                      option.value.
                                      toUpperCase().
                                      indexOf(
                                      inputValue.toUpperCase()) !==
                                      -1}>

                                        
                                              <Input
                                        className={
                                        industryNameError ?
                                        "percentInputError" :
                                        "contractgig-input"}

                                        onKeyPress={(event) => {
                                          if (
                                          event.which ===
                                          13 /* Enter */)
                                          {
                                            event.preventDefault();
                                          }
                                        }}
                                        placeholder="Industry"
                                        type={"input"}
                                        value={industryValue}
                                        onChange={(e) =>
                                        setindustryValue("")} />

                                        
                                            </AutoComplete>
                                          </div>
                                          <div style={{ width: "20.5%" }}>
                                            <Input
                                      type={"input"}
                                      className={`contractgig-input ${
                                      industryerror ?
                                      "percentInputError" :
                                      ""
                                      }`}
                                      onKeyPress={(event) => {
                                        if (
                                        event.which === 13 /* Enter */)
                                        {
                                          event.preventDefault();
                                        }
                                      }}
                                      placeholder="%"
                                      value={percentage2}
                                      // defaultValue={industryfill[0]?.IndustryPercent}
                                      onChange={(e) =>
                                      setpercentage2(
                                      e.target.value.trim())} />


                                      
                                          </div>
                                        </div>
                                        <div style={{ width: "15%" }}>
                                          <Col
                                    span={24}
                                    style={{
                                      display: "flex",
                                      // justifyContent: "center",
                                      alignItems: "center",
                                      height: "88%"
                                    }}>
                                      
                                            <div
                                      onClick={addIndustryPercent}
                                      className={"contractgig-add-btn"}>
                                        
                                              ADD
                                            </div>
                                          </Col>
                                        </div>
                                      </Row>
                                    </Form.Item> :
                              null}
                                </div>
                                {industrySuggestionsError ?
                            <div
                            className="totalerrorMsg"
                            style={{ margin: "0px" }}>
                              
                                    Please add an industry from suggestions
                                  </div> :
                            null}
                                <div className="contractgig-Divider"></div>
                                <div className="contractgig-total">
                                  Total: {mypercent2}%
                                </div>

                                {mypercent2 < 100 &&
                            industryDetails?.length > 0 &&
                            industryDetails?.every(
                            (el) => el.isDisable == true) ?

                            <div style={{ display: addIndustryBtn }}>
                                    <Button
                              className="add-new-skill-btn"
                              onClick={() => {
                                setindustryDetails((prev) =>
                                prev.map((el) => ({
                                  ...el,
                                  isDisable: true
                                })));

                                setaddIndustryInput("block");
                                setpercentage2("");
                              }}>
                                
                                      <Row>
                                        <Col className="plus-Icon">+</Col>
                                        <Col className="btn-Text">
                                          Add a new industry
                                        </Col>
                                      </Row>
                                    </Button>
                                  </div> :
                            null}
                              </div>
                            </Col>
                          </Row>}
                      
                      </div>
                    </div>
                    {industryDetails?.length > 0 && (
                  industryerror ?
                  <div className="totalerrorMsg">
                          Total cannot be more than 100%
                        </div> :
                  industryDecimalError ?
                  <div className="totalerrorMsg">
                          Industry density percentage should be a whole number
                        </div> :
                  industryDuplicateError ?
                  <div className="totalerrorMsg">
                          Duplicate industry names not allowed
                        </div> :
                  industryPercentValidator && mypercent2 < 100 ?
                  <div className="totalerrorMsg">Total must be 100%</div> :
                  null)}
                  </Col>
                </Form.Item>}
              
            </Row>

            <Row
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              rowGap: "1.25rem"
            }}>
              
              {locationn.state?.PermanentJob ||
              locationn.state?.JobOrderTypeName == "Permanent" ||
              getEditQuery?.JobOrderTypeName == "Permanent" ? null :
              <Col className="contractgig-md1234">
                  <Row className="contractgig-heading">
                    <div className="contractgig-title">Job Duration</div>
                    <div className="contractgig-asterik"> *</div>
                  </Row>
                  <Form.Item
                name="JobDuration"
                rules={[
                {
                  required: true,
                  message: "Choose the job duration"
                }]}>

                  
                    <Select
                  placeholder="Job duration"
                  style={{
                    width: "100%",
                    border: "solid 1px #d4d4d4"
                  }}
                  suffixIcon={<DownOutlined style={{ color: "#5e5e5e" }} />}
                  size={"large"}
                  className="workplace-policy-select"
                  popupClassName="contract-gig-select-class"
                  onChange={dropdownSelect2}>
                    
                      {JobDurationArray?.map((items, index) => {
                      return (
                        <Option key={index} value={items}>
                            {items}
                          </Option>);

                    })}
                    </Select>
                  </Form.Item>
                </Col>}
              

              {/* Gig location thingy */}

              {workpolicy !== "fully-remote" &&
              <Col className="contractgig-md1234">
                  <Row className="contractgig-heading">
                    <div className="contractgig-title">Job Location</div>
                    <div className="contractgig-asterik"> *</div>
                  </Row>
                  <div>
                    <Form.Item
                  className="Place"
                  name="locationValuee"
                  rules={[
                  // {
                  //   required: true,
                  //   message: "Please select the suggested Location",
                  // },
                  {
                    validator: (_, value) => {
                      let status = false;
                      for (
                      let index = 0;
                      index < filters.length;
                      index++)
                      {
                        if (
                        filters[index]?.LocationWithCountry ==
                        locationValue)
                        {
                          status = true;
                        }
                      }
                      if (validationCheck) {
                        if (status || typeof locobj === "object") {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(
                          new Error(
                          "Please select the suggested location"));


                        }
                      } else if (!validationCheck) {
                        if (value || locationValue) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(
                          new Error(
                          "Please select the suggested location"));


                        }
                      }
                    }
                  }]}>

                    
                      <AutoComplete
                    popupClassName="post-job-form-dropdowns"
                    options={location}
                    style={{
                      width: "100%"
                    }}
                    onSelect={onSelect}
                    listHeight={160}>
                      
                        <Input
                      className="contractgig-input"
                      placeholder="Add the job’s location"
                      onKeyPress={(event) => {
                        if (event.which === 13 /* Enter */) {
                          event.preventDefault();
                        }
                      }}
                      type={"input"}
                      value={locationValue}
                      onChange={debounce((e) => {
                        setLocationValue(e.target.value.trim());
                        setlocobj("");
                        setLocation("");
                        setValidationCheck(false);
                      })} />
                      
                      </AutoComplete>
                    </Form.Item>
                  </div>
                </Col>}
              

              <Col className="contractgig-md1234">
                <Row className="contractgig-heading">
                  <div className="contractgig-title">
                    Desired&nbsp;Years&nbsp;Of&nbsp;Experience
                  </div>
                  <div className="contractgig-asterik"> *</div>
                </Row>
                <Form.Item
                name="desiredExp"
                rules={[
                {
                  required: true,
                  message: "Choose desired years of experience"
                }]}>

                  
                  <Select
                  style={{
                    width: "100%",
                    border: "solid 1px #d4d4d4"
                  }}
                  suffixIcon={<DownOutlined style={{ color: "#5e5e5e" }} />}
                  popupClassName="post-job-form-dropdowns"
                  size={"large"}
                  onChange={handleChange2}
                  placeholder="Select desired experience"
                  mode="multiple">
                    
                    {EXPERIENCE_LEVELS?.map((item) => {
                      return (
                        <Select.Option
                        key={Number(item.ExperienceLevelId)}
                        value={Number(item.ExperienceLevelId)}>
                          
                          {/* // <Select.Option key={parseInt(item.ExperienceLevelId)}> */}
                          {item.ExperienceLevelName === "> 10 Years" ?
                          "More than 10 years" :
                          item.ExperienceLevelName}
                        </Select.Option>);

                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Row className="contractgig-btn-mv">
                <button
                className={"contractgig-cancel-btn"}
                onClick={() =>
                history?.replace({
                  pathname:
                  locationn.state.from === "JobDetail" ?
                  `/jobdetail/${locationn.state?.Id}` :
                  locationn.state.from === "Templates" ?
                  "/postajob/choosetemplate" :
                  locationn.state.from === "ManageGigs" ?
                  "/joblisting" :
                  locationn.state.from === "MyMatches" ?
                  "/mymatches" :
                  history.goBack(),
                  state: {
                    ...(locationn?.state || {}),
                    id:
                    locationn.state.from === "JobDetail" &&
                    locationn.state?.Id,
                    PermanentJob: locationn.state.PermanentJob ?
                    true :
                    false,
                    ...(locationn?.state || {})
                  }
                })}>

                  
                  Cancel
                </button>

                <Form.Item>
                  <button
                  className="contractgig-next-btn"
                  // onClick={() => ConGigSubmit()}
                  >
                    {loadingJobCreate || loadingJobUpdate ?
                    <LoadingOutlined /> :

                    "Next"}
                    
                  </button>
                </Form.Item>
              </Row>
            </div>
          </Form>
        </div>
      </Col>
    </Row>);

}